import type { ReceiptAuditSimulationExpandedPreview } from '../../../../types/services/audit';
import type { AuditVarianceByGameId, AuditVarianceStatus } from '../../../../types/auditVarianceTypes';

const parseOptionalNumber = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const buildAuditVarianceByGameId = (
  expandedPreview?: ReceiptAuditSimulationExpandedPreview | null,
): AuditVarianceByGameId => {
  const gamesRaw = expandedPreview?.games;
  const games = Array.isArray(gamesRaw) ? gamesRaw : [];
  const nextMap: AuditVarianceByGameId = {};

  for (const game of games) {
    const gameId = game?.game_id != null ? String(game.game_id) : '';
    if (!gameId) {
      continue;
    }

    const quantityVariance = parseOptionalNumber(game?.reconciliation_variance?.quantity_variance);
    const revenueVariance = parseOptionalNumber(game?.reconciliation_variance?.revenue_variance);
    const isMatch = quantityVariance === 0;

    const status: AuditVarianceStatus =
      quantityVariance === undefined
        ? 'unknown'
        : isMatch
          ? 'match'
          : 'discrepancy';

    nextMap[gameId] = {
      quantityVariance,
      revenueVariance,
      status,
    };
  }

  return nextMap;
};
